import { render, staticRenderFns } from "./IryohokenRowsDataTable.vue?vue&type=template&id=6f7947be&"
import script from "./IryohokenRowsDataTable.vue?vue&type=script&lang=ts&"
export * from "./IryohokenRowsDataTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports